import { useMemo } from 'react';
import { useGetHubDevicesQuery } from '../../../rtk/hubDevicesApi';
import { useGetFavouriteHubDeviceIdsQuery } from '../../../rtk/userPreferencesApi';

const useHubDevices = () => {
  const { data: allHubDevices = [], ...hubDevicesState } =
    useGetHubDevicesQuery();
  const { data: favouriteIds = [], ...favouriteState } =
    useGetFavouriteHubDeviceIdsQuery();

  const favouriteHubDevices = useMemo(
    () =>
      allHubDevices
        .filter((device) => favouriteIds.includes(device.duid))
        .map((device) => ({ ...device, isFavourite: true })),
    [allHubDevices, favouriteIds],
  );

  const hubDevices = useMemo(
    () =>
      allHubDevices.map((device) =>
        favouriteIds.includes(device.duid)
          ? { ...device, isFavourite: true }
          : device,
      ),
    [allHubDevices, favouriteIds],
  );

  return {
    hubDevices,
    favouriteHubDevices,
    isLoading: hubDevicesState.isLoading || favouriteState.isLoading,
    isError: hubDevicesState.isError || favouriteState.isError,
  };
};

export default useHubDevices;
